import { AppNonStandardCustom } from "../appNonStandardConfig/appNonStandardCustom";
import CartConfigMainLogicNew from "../optionalFeatures/cartConfiguration/components/CartConfigMainLogicNew";
import  { CatalogueConfigCustomDummyImageUpload, CatalogueConfigCustomFilter, CatalogueConfigCustomLabels, CatalogueConfigCustomPriceFormatted, CatalogueConfigCustomSimilarProductGrouping, CatalogueConfigCustomSkuTile } from "../optionalFeatures/catelogueConfig/CatalogueConfigCustom";
import OrderSummaryConfigCustom from "../optionalFeatures/orderSummary/OrderSummaryConfigCustom";
import OrderTrackingConfigCustom from "../optionalFeatures/OrderTrackingConfig/OrderTrackingConfigCustom";
import { PasswordComplexityCustom, PasswordDeactivateInactiveUsers, PasswordRetry } from "../PasswordConfiguration/passwordConfigurationCustom";
import ProjectConfigCustom, { ProjectConfigCustomLob, ProjectDevelopedConfigurations } from "../projectConfig/ProjectConfigCustom";

interface Props {
  values: any;
  name: string;
  setValues: React.Dispatch<React.SetStateAction<any>>;
  extraAttributes?:any
}

const CustomMap: Record<string, any> = {
  ordertracking_ordertrackingstages: OrderTrackingConfigCustom,
  cart_cart:CartConfigMainLogicNew ,
  catalogue_catalogue:CatalogueConfigCustomFilter,
  ordersummary_ordertnclink:OrderSummaryConfigCustom,
  uiandtheme_appbarbackgroundtype:AppNonStandardCustom,
 project_countrycode:ProjectConfigCustom,
 project_lob:ProjectConfigCustomLob,
 catalogue_showskucode:CatalogueConfigCustomSkuTile,
 catalogue_similarproduct:CatalogueConfigCustomSimilarProductGrouping,
  catalogue_dummyimageupload:CatalogueConfigCustomDummyImageUpload,
  catalogue_labels:CatalogueConfigCustomLabels,
  catalogue_priceformatter:CatalogueConfigCustomPriceFormatted,
 projectnonstandard_developerconfigurations:ProjectDevelopedConfigurations,
 projectnonstandard_countrycode:ProjectConfigCustom,
 authentication_passwordcomplexity:PasswordComplexityCustom,
 authentication_userloginblock:PasswordRetry,
 authentication_userinactivityblock:PasswordDeactivateInactiveUsers,
};

const CustomComponentMapping: React.FC<Props> = (props) => {
  const Component = CustomMap[props.name];
  if (!Component) return null; 
  if(props.name==="cart_cart"){
   return <CartConfigMainLogicNew values={props.values} updateValues={props.setValues} avalableBuckets={[]} savedRole={props.extraAttributes?.savedRole} isSaveAttempted={false}   />
  }
  return <Component {...props} />;
};

export default CustomComponentMapping;

